import { PAYMENT_TYPE } from '../../main/payment/constants';
import { GLYPHS } from '../../common/icon';
import squireLogo from '../../../../images/squire_circle_logo.png';


export const MAX_SUMMARY_ENTRIES = 10000;
export const CELL_WIDTH_LED = 30;
export const CELL_WIDTH_STATUS = 30;
export const ICON_TYPE = {
  icon: 'icon',
  image: 'image',
};
export const PAYMENT_ICON = {
  [PAYMENT_TYPE.cash]: {
    type: ICON_TYPE.icon,
    value: GLYPHS.dollar,
  },
  [PAYMENT_TYPE.giftCard]: {
    type: ICON_TYPE.icon,
    value: GLYPHS.giftCard,
  },
  [PAYMENT_TYPE.card]: {
    type: ICON_TYPE.icon,
    value: GLYPHS.creditCard,
  },
  [PAYMENT_TYPE.reader]: {
    type: ICON_TYPE.icon,
    value: GLYPHS.creditCard,
  },
  [PAYMENT_TYPE.readerless]: {
    type: ICON_TYPE.icon,
    value: GLYPHS.creditCard,
  },
  payout: {
    type: ICON_TYPE.icon,
    value: GLYPHS.dollar,
  },
  isViaOnline: {
    type: ICON_TYPE.image,
    value: squireLogo,
  },
};


// Actions
export const REGISTER_FETCH_SUMMARY_START = 'REGISTER_FETCH_SUMMARY_START';
export const REGISTER_FETCH_SUMMARY = 'REGISTER_FETCH_SUMMARY';
export const REGISTER_REFUND_SALE = 'REGISTER_REFUND_SALE';
export const REGISTER_REFUND_CUSTOM_CHARGE = 'REGISTER_REFUND_CUSTOM_CHARGE';
export const REGISTER_REFUND_RECURRING_MEMBERSHIP = 'REGISTER_REFUND_RECURRING_MEMBERSHIP';
export const REGISTER_REASSIGN_SALE = 'REGISTER_REASSIGN_SALE';
export const SET_REFUND_DATA = 'SET_REFUND_DATA';
